import React from 'react';
import Header from './../Header/Header'
import Footer from './../Footer/Footer'
import ContactForm from './ContactForm'

// Contact stateless component
const Contact = () =>
	<div>
		<Header />
		<section className="hero is-fullheight">
			<div className="hero-body">
				<div className="container">
					<div className="columns is-centered">
						<div className="column is-10-tablet is-8-desktop is-6-widescreen">
							<ContactForm />
						</div>
					</div>
				</div>
			</div>
		</section>
		<Footer />
	</div>

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js